(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_outfit-button"] && !Shopify.designMode) return;
  try {
    class OutfitButtonComponent extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.outfit-button');
      this.productId = this.dataset.productId;
      this.metafieldName = this.dataset.metafieldName;
      this.init();
    }

    init() {
      if (this.button) {
        this.button.addEventListener('click', this.handleClick.bind(this));
      }
    }

    async handleClick(event) {
      event.preventDefault();

      if (this.button.dataset.loading === 'true') {
        return;
      }

      this.setLoading(true);

      try {
        // Get product data
        const productData = this.getProductData();

        if (!productData) {
          throw new Error('Product data not available');
        }

        // Save to session storage
        this.saveToSessionStorage(productData);

        // Navigate to ghost template
        this.navigateToGhostTemplate();
      } catch (error) {
        console.error('Error adding product to outfit:', error);
        this.showError('Failed to add product to outfit. Please try again.');
      } finally {
        this.setLoading(false);
      }
    }

    getProductData() {
      // Get product data from the JSON script tag
      const productDataScript = document.getElementById(`outfit-product-data-${this.productId}`);

      if (productDataScript) {
        try {
          return JSON.parse(productDataScript.textContent);
        } catch (error) {
          console.error('Error parsing product data:', error);
          return null;
        }
      }

      return null;
    }

    saveToSessionStorage(productData) {
      // Create ghost product card data structure with essential data only
      const ghostProductData = {
        // Essential product info
        id: productData.id,
        title: productData.title,
        price: productData.price,
        compare_at_price: productData.compare_at_price,
        available: productData.available,

        // Variants
        variants: productData.variants,
        options2: productData.options2,
        // Images
        featured_image: productData.featured_image,

        // Ghost-specific data
        ghost_template: 'ghost-products',
        url: productData.url,
        added_at: new Date().toISOString(),
      };

      // Save to session storage
      sessionStorage.setItem('pdpGhostProductCardData', JSON.stringify(ghostProductData));
    }

    navigateToGhostTemplate() {
      // Navigate to the ghost products template
      const ghostUrl = 'https://torqadorn.com/collections/best-sellers-1?view=ghost-products';

      // Dispatch event to show modal immediately
      document.dispatchEvent(
        new CustomEvent('ghost-product-navigation', {
          detail: { productData: JSON.parse(sessionStorage.getItem('pdpGhostProductCardData')) },
        })
      );

      // Navigate to ghost template
      window.location.href = ghostUrl;
    }

    setLoading(loading) {
      if (loading) {
        this.button.dataset.loading = 'true';
        this.button.disabled = true;
      } else {
        this.button.dataset.loading = 'false';
        this.button.disabled = false;
      }
    }

    showError(message) {
      // You can implement a toast notification or other error display here
      console.error(message);
      alert(message); // Simple fallback
    }
  }

  customElements.define('outfit-button-component', OutfitButtonComponent);
  } catch(e) { console.error(e); }
})();

})();
